import { get, isEmpty, isNull } from 'lodash';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Table from '../../../../../../../common/components/table/components/Table';
import { setPageNotification } from '../../../../../../../common/components/with_page/redux/reducer';
import { SUPPORTED_IMPORT_TYPES } from '../../../../../../import_data/constants/import_types';
import {
  getImportFailureNotification,
  getImportTypeMetadataForHeader,
  processUserLevelImportMetadata,
} from '../../../../../../import_data/utils/import_utils';
import costCentersTableConfig from '../constants/cost_centers_table_config';
import { searchCostCentersQNQAction } from '../redux/costCentersQnq';
import { getImportMetadataAction } from '../../../../../../import_data/redux/GetImportMetadata';

const CostCentersTable = props => {
  const { importMetadata, pushNotification, entityId } = props;
  const supportedImportTypes = SUPPORTED_IMPORT_TYPES.QNQ_CC;
  const [latestImportTypeMetadata, setLatestImportTypeMetadata] = React.useState(null);

  useEffect(() => {
    if (!isEmpty(importMetadata)) {
      const importTypeMetadata = getImportTypeMetadataForHeader(
        importMetadata,
        supportedImportTypes,
      );
      setLatestImportTypeMetadata(importTypeMetadata);

      const userLevelImportMetadata = processUserLevelImportMetadata(importMetadata);
      if (!isNull(userLevelImportMetadata)) {
        pushNotification(
          getImportFailureNotification({
            tableIdentifier: 'CostCentersTable',
            ...userLevelImportMetadata,
            supportedImportTypes,
          }),
        );
      }
    }
  }, [importMetadata, supportedImportTypes, pushNotification]);

  return (
    <Table
      {...props}
      config={costCentersTableConfig({ importTypeMetadata: latestImportTypeMetadata, entityId })}
    />
  );
};

CostCentersTable.propTypes = {
  schema: PropTypes.array.isRequired,
  data: PropTypes.object.isRequired,
  isFetchingData: PropTypes.bool.isRequired,
  getDataBegin: PropTypes.func.isRequired,
  clearData: PropTypes.func.isRequired,
  importMetadata: PropTypes.array.isRequired,
  pushNotification: PropTypes.func.isRequired,
  getImportDataBegin: PropTypes.func.isRequired,
  getImportDataClear: PropTypes.func.isRequired,
  entityId: PropTypes.string,
};

const mapStateToProps = state => {
  return {
    schema: get(state, 'entities.schemas.data.pages.qnq.costCenters', []) || [],
    data: get(state, 'entities.qnq.costCenters.data', {}) || {},
    totalResultCount: get(state, 'entities.qnq.costCenters.data.totalResultCount', 0) || 0,
    isFetchingData: get(state, 'entities.qnq.costCenters.isFetching', false) || false,
    importMetadata: get(state, 'entities.getImportMetadata.data.body.importMetadata', []) || [],
    entityId: get(state, 'entityId.entityId'),
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getDataBegin: searchCostCentersQNQAction.BEGIN,
      clearData: searchCostCentersQNQAction.CLEAR,
      pushNotification: setPageNotification,
      getImportDataBegin: getImportMetadataAction.BEGIN,
      getImportDataClear: getImportMetadataAction.CLEAR,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(CostCentersTable);
